

let flickityInstances = [];

function setupFlickity() {
    const isMobile = window.innerWidth <= 999;
    const carousels = document.querySelectorAll('.js-main-carousel');

    if (!carousels.length) return;

    carousels.forEach((carousel, index) => {
        const existing = flickityInstances[index];

        // Destroy if Flickity exists and screen is not mobile
        if (existing && !isMobile) {
            existing.destroy();
            flickityInstances[index] = null;
        }

        // Initialize Flickity if mobile and not already initialized
        if (isMobile && !existing) {
            const flkty = new Flickity(carousel, {
                cellAlign: 'left',
                contain: true,
                watchCSS: false,
                prevNextButtons: false, // Disable arrows
                pageDots: false          // Disable dots
            });
            flickityInstances[index] = flkty;
        }
    });
}

setupFlickity();
window.addEventListener('resize', setupFlickity);
